import React, { useReducer } from "react";
import useSWR from "swr";
import AggregateBottomButton from "../components/AggregateBottomButton";
import { JsonLdTags } from "../components/JsonLd";
import ReviewList from "../components/ReviewList";
import { AppContext, defaultAppState, reducer } from "./All";

const AggregateReviews = (props) => {
  const fetcher = (...args) => fetch(...args).then((r) => r.json());
  const { data } = useSWR(`${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}/aggregate.json?currentLocationReviewsOnly=${props.currentLocationReviewsOnly}&widget=aggregate`, fetcher, {
    revalidateOnFocus: false,
  });
  const [state, dispatch] = useReducer(reducer, defaultAppState);

  if (!data) {
    return null;
  }

  const { merchant } = data;
  const {
    truncateDest,
    lines,
    num,
    randomize,
    thirdParty,
    currentLocationReviewsOnly,
    writeDisable = false
  } = props

  return (
    <AppContext.Provider value={{ state, dispatch, settings: { ...props } }}>
      <div id="reviews">
        <JsonLdTags merchant={merchant} reviews={state.reviews} />
        <ReviewList
          merchant={merchant}
          hidePlatform={true}
          truncateDest={truncateDest}
          truncateText={true}
          truncateAt={lines}
          state={merchant.state}
          hideResponses={true}
          page={1}
          limit={num}
          expandInline={false}
          randomize={randomize}
          thirdParty={thirdParty}
          skipPagination={true}
          currentLocationReviewsOnly={currentLocationReviewsOnly}
        />
        <AggregateBottomButton merchant={merchant} writeDisable={writeDisable} truncateDest={truncateDest} />
      </div>
    </AppContext.Provider>
  );
};

export default AggregateReviews;



// WEBPACK FOOTER //
// ./src/containers/AggregateReviews.jsx